import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState('');
  const [sent, setSent]     = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email) { setError(t('auth.email_required')); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch('/api/auth/forgot-password', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Erreur');
      setSent(true);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{
      minHeight:'100vh',
      background:'linear-gradient(135deg, #1A1A1A 0%, #2D2D2D 50%, #1A1A1A 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:20,
      fontFamily:"'Segoe UI', system-ui, sans-serif",
    }}>
      <div style={{ position:'fixed', top:0, left:0, width:200, height:4,
        background:'linear-gradient(90deg, #F18A00, transparent)' }}/>

      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontSize:30, fontWeight:900, letterSpacing:'-1px', color:'#fff' }}>
            ARCUS<span style={{ color:'#F18A00' }}>CONNECT</span>
          </div>
          <div style={{ fontSize:12, color:'#64748B', marginTop:4, letterSpacing:'.12em', textTransform:'uppercase' }}>CRM</div>
        </div>

        <div style={{ background:'#fff', borderRadius:16, padding:36, boxShadow:'0 25px 60px rgba(0,0,0,.4)' }}>
          {!sent ? (
            <>
              <h1 style={{ fontSize:20, fontWeight:700, margin:'0 0 6px', color:'#1A1A1A' }}>{t('auth.forgot_title')}</h1>
              <p style={{ fontSize:13, color:'#64748B', margin:'0 0 22px' }}>{t('auth.forgot_desc')}</p>

              {error && (
                <div style={{ background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 }}>
                  ⚠ {error}
                </div>
              )}

              <form onSubmit={submit}>
                <div style={{ marginBottom:18 }}>
                  <label style={{ fontSize:12, fontWeight:500, color:'#64748B', display:'block', marginBottom:6 }}>{t('auth.email')}</label>
                  <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
                    placeholder={t('auth.email_placeholder')} autoFocus
                    style={{ width:'100%', boxSizing:'border-box', border:'1.5px solid #E5E7EB', borderRadius:8,
                      padding:'11px 14px', fontSize:14, fontFamily:'inherit', outline:'none', transition:'border-color .15s' }}
                    onFocus={e=>e.target.style.borderColor='#F18A00'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
                </div>
                <button type="submit" disabled={loading}
                  style={{ width:'100%', padding:'12px', background:'#F18A00', color:'#161616',
                    border:'none', borderRadius:8, fontSize:15, fontWeight:500,
                    cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? .7 : 1 }}>
                  {loading ? '…' : t('auth.forgot_btn')}
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ background:'#E1F5EE', border:'1px solid #B6E5D2', borderRadius:10,
                padding:'14px 16px', marginBottom:18, color:'#0F6E56', fontSize:13, display:'flex', alignItems:'center', gap:9 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 7l9 6l9 -6M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"/>
                </svg>
                {t('auth.forgot_sent')}
              </div>
            </>
          )}

          <div style={{ textAlign:'center', marginTop:18, paddingTop:18, borderTop:'1px solid #F3F4F6' }}>
            <button onClick={() => navigate('/')} type="button"
              style={{ fontSize:13, color:'#64748B', background:'none', border:'none', cursor:'pointer', textDecoration:'underline' }}>
              ← {t('auth.back_to_login')}
            </button>
          </div>
        </div>

        <div style={{ textAlign:'center', marginTop:20, fontSize:11, color:'#4B5563' }}>
          Arcus Solutions · arcus-solutions.fr
        </div>
      </div>
    </div>
  );
}
